import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Panel } from '../../../common/panel'
import { initCollapse, selectDataById, selectLoading } from './store/slice'

import useGetVsic from '../../../common/category/useGetVsic'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { HIGH_LIGHT_TITLE, SCORE_OPTION } from '../constants'
import { selectCurrentScore } from '../store/slice'
import { sortByParentId } from './helper'
import { exportIndustry, getIndustry } from './store/thunk'
import TableComponent from './table/TableComponent'

const Industry = () => {
  const dispatch = useDispatch()
  const settingParams = useSettingParams()
  const { loading: vsicLoading, vsics: vsicData } = useGetVsic()

  const isLoading = useSelector(selectLoading)
  const currentScore = useSelector(selectCurrentScore)
  const dataById = useSelector(selectDataById)
  const locale = useSelector((state) => state.i18n.locale)

  const treeData = useMemo(() => {
    return sortByParentId(vsicData)
  }, [vsicData])

  const isCreditScore = currentScore === SCORE_OPTION.CREDIT_SCORE

  useEffect(() => {
    if (!settingParams) return
    dispatch(getIndustry(settingParams))
  }, [settingParams, locale])

  useEffect(() => {
    dispatch(initCollapse(vsicData))
  }, [vsicData])

  return (
    <Panel
      label="portfolio.segment.BY_INDUSTRY"
      isI18n={true}
      renderLabel={() => <span className="fstItalic">&nbsp;(VSIC)</span>}
      downloadCsv={{ downloadFunc: () => exportIndustry(settingParams) }}
      className={HIGH_LIGHT_TITLE.mainSector}
    >
      <TableComponent
        isLoading={isLoading || vsicLoading}
        data={Object.keys(dataById)}
        isCreditScore={isCreditScore}
        treeData={treeData}
      />
    </Panel>
  )
}

export default Industry
